/**
 * @class
 * @todo finish documentation
 */
import {getPrefixedLogger} from '@netx/core-next/instance/logger';
import Base from '@netx/core/lib/netx-collection';
import Model from '../models/CMSMenu';

const logger = getPrefixedLogger('models/CMSMenu');

export default class CMSMenus extends Base {
	/**
	 * @type {Netx.Rpc}
	 * @private
	 */
	get rpc() {
		return true;
	}

	/** @type {boolean} */
	get xhrTrackProgress() {
		return true;
	}

	/**
	 * @property {object} methods - The methods available on this model
	 */
	get methods() {
		return {
			getMenusForPortal: ['getMenusForPortal', 'portalId'],
			fetchAll: ['getAllMenus'],
		};
	}

	/**
	 * parsers for rpc methods
	 * @type {object}
	 */
	get parsers() {
		return {
			/**
			 * @method
			 * @param {array} menus
			 */
			getMenusForPortal(menus, opts) {
				this.set(menus);
				// only supporting one menu right now
				this.current = new this.model(menus[0]);
			},
			/**
			 * @method
			 * @param {array} menus
			 */
			fetchAll(menus, opts) {
				this.set(menus);
			},
		};
	}

	/** @override */
	constructor(models, opts = {}) {
		opts.model = opts.model || Model;

		super(models, opts);

		// only one menu implemented "currently"
		this.current = new this.model({portalId: opts.portalId});

		/**
		 * Name of a portal -- for getMenusForPortal()
		 * @property {string}
		 */
		this.portalId = opts.portalId;

		// Hey, listen!
		this.listenTo(
			dispatcher,
			'cms:action:delete:success',
			this.deleteActionSuccess,
		);
	}

	/**
	 * @method
	 * @param {int} portalId
	 * @param {object} opts
	 */
	fetchPortal(portalId, opts) {
		this.portalId = portalId;
		return this.getMenusForPortal.call(this, opts);
	}

	/**
	 * @method
	 * @param {object} action
	 */
	deleteActionSuccess(action) {
		if (!action) return;

		// if this action is in our current (only) menu, remove it
		if (this.current.get('name').length === 0) {
			this.current.set({name: 'main'});
			this.current.fetch().then((action) => {
				this.removeActionFromMenu(action);
			});
		} else {
			this.removeActionFromMenu(action);
		}
	}

	/**
	 * @method
	 * removes action from menu
	 * @param {object} action
	 */

	removeActionFromMenu(action) {
		if (!action) return;
		const removedInt = this.current.removeAction(action.event);
		if (removedInt) {
			this.current.save().then(() => {
				dispatcher.trigger('cms:menu:remove:success');
			});
		} else {
			logger.warn('no menu to remove');
		}
	}

	/** @type {string} */
	static get __name__() {
		return 'CMSMenus';
	}
}
